import { NgModule } from '@angular/core';
import { NimbusMaterialButtonsRowDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-buttons-row.directive';
import { NimbusMaterialIconPrimaryButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-icon-primary-button.directive';
import { NimbusMaterialInvertedButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-inverted-button.directive';
import { NimbusMaterialNegativeButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-negative-button.directive';
import { NimbusMaterialNoBorderPrimaryButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-no-border-primary-button.directive';
import { NimbusMaterialPrimaryButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-primary-button.directive';
import { NimbusMaterialSecondaryButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-secondary-button.directive';
import { NimbusMaterialIconNegativeButtonDirective } from '@nimbus-library/features/shared/components/material/buttons/nimbus-material-icon-negative-button.directive';

@NgModule({
  exports: [
    NimbusMaterialPrimaryButtonDirective,
    NimbusMaterialSecondaryButtonDirective,
    NimbusMaterialInvertedButtonDirective,
    NimbusMaterialButtonsRowDirective,
    NimbusMaterialNegativeButtonDirective,
    NimbusMaterialIconPrimaryButtonDirective,
    NimbusMaterialIconNegativeButtonDirective,
    NimbusMaterialNoBorderPrimaryButtonDirective,
  ],
  declarations: [
    NimbusMaterialPrimaryButtonDirective,
    NimbusMaterialSecondaryButtonDirective,
    NimbusMaterialInvertedButtonDirective,
    NimbusMaterialButtonsRowDirective,
    NimbusMaterialNegativeButtonDirective,
    NimbusMaterialIconPrimaryButtonDirective,
    NimbusMaterialIconNegativeButtonDirective,
    NimbusMaterialNoBorderPrimaryButtonDirective,
  ],
})
export class NimbusMaterialButtonModule {}
